// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kapsalon-js": () => import("./../../../src/pages/kapsalon.js" /* webpackChunkName: "component---src-pages-kapsalon-js" */),
  "component---src-pages-kapsalon-kelly-js": () => import("./../../../src/pages/kapsalon-kelly.js" /* webpackChunkName: "component---src-pages-kapsalon-kelly-js" */)
}

